<script setup lang="ts">
import { isSub, parentOf } from '~/shared/allergenHierarchy'

const props = defineProps<{
  icon: string
}>()

const { styles } = useVariants('menuIcon')

// Sub-allergens have no dedicated SVG; they reuse their parent's icon.
const imageId = computed(() => (isSub(props.icon) ? parentOf(props.icon)! : props.icon))
</script>

<template>
  <div>
    <span :class="styles.base()">
      <img
        :src="`/images/icons/${imageId.toLowerCase()}.svg`"
        :alt="icon"
        class="h-4.5 w-4.5"
      >
    </span>
  </div>
</template>
